// extracted by mini-css-extract-plugin
module.exports = {"tooltipOpener":"tooltipOpener--0ks7j","collapseCard":"collapseCard--9SfW-","collapse":"collapse--fRa5x"};